import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=75db000c&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"
import style0 from "./MainComponent.vue?vue&type=style&index=0&id=75db000c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db000c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75db000c')) {
      api.createRecord('75db000c', component.options)
    } else {
      api.reload('75db000c', component.options)
    }
    module.hot.accept("./MainComponent.vue?vue&type=template&id=75db000c&scoped=true", function () {
      api.rerender('75db000c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/Views/MainComponent.vue"
export default component.exports